<script setup lang="ts">
import { connectCurrentRefinements } from 'instantsearch.js/es/connectors';
import {
  CurrentRefinementsConnectorParams,
  CurrentRefinementsWidgetDescription,
} from 'instantsearch.js/es/connectors/current-refinements/connectCurrentRefinements';
import { computed, PropType } from 'vue';

import { useWidget } from '@/composables/instant-search/useWidget';

const props = defineProps({
  // no default because included and excluded are incompatible
  // eslint-disable-next-line vue/require-default-prop
  excludedAttributes: {
    required: false,
    type: Array as PropType<CurrentRefinementsConnectorParams['excludedAttributes']>,
  },
  // no default because included and excluded are incompatible
  // eslint-disable-next-line vue/require-default-prop
  includedAttributes: {
    required: false,
    type: Array as PropType<CurrentRefinementsConnectorParams['includedAttributes']>,
  },
  isAbbreviated: { required: false, type: Boolean, default: false },
});

const emit = defineEmits(['open-filters']);

const widgetParams = computed<CurrentRefinementsConnectorParams>(() => ({
  excludedAttributes: props.excludedAttributes,
  includedAttributes: props.includedAttributes,
}));

const { state } = useWidget<CurrentRefinementsWidgetDescription, CurrentRefinementsConnectorParams>(
  { connector: connectCurrentRefinements },
  widgetParams,
);

const noRefinement = computed(() => state.value?.items.length === 0);
const refinementCount = computed(
  () => state.value?.items.reduce((count, { refinements }) => count + refinements.length, 0) ?? 0,
);
const refinementText = computed(() => {
  let content = `${refinementCount.value}`;
  if (!props.isAbbreviated) content += ' Applied';
  return `(${content})`;
});
</script>

<template>
  <button
    class="reveal-filters"
    @click.prevent="$emit('open-filters')"
    data-test="reveal-filters-mobile"
  >
    <slot>Filter &amp; Sort</slot>
    <span v-if="!noRefinement">&nbsp;{{ refinementText }}</span>
  </button>
</template>
